import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-image-section-head',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './image-section-head.component.html',
  styleUrl: './image-section-head.component.scss'
})
export class ImageSectionHeadComponent {
  @Input() title: string = '';
  @Input() description: string = '';
  @Input() image: string = '';
}
